// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__pwlsi","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Z41q"};